import * as React from 'react'
import {Box} from '@mui/material'
import {OcThemeProvider, OcWebsocket, SnackHandlerInstance as snackHandler} from '@oc/shell-core'
import {AppDrawer} from './Drawer'
import {OcAppBar, ocAppBarHeight} from './AppBar/OcAppBar'
import {OcAppBarStateContextProvider} from '../Contexts/OcAppBarStateContext'
import {makeStyles} from '@oc/styles'
import {messages} from './translations'

const useStyles = makeStyles({
    fullWidth: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'auto'
    },
    fullHeight: {
        height: `calc(100vh - ${ocAppBarHeight}px)`
    }
})

interface UiDeployMessage {
    /**
     * OC URL which was just deployed
     * @example https://console.share2act-dev.io
     * @example https://custom-environment.oc.share2act-test.io
     */
    url: string
}

export const RootLayout = ({children}: React.PropsWithChildren) => {
    const {classes} = useStyles()

    const onMessage = React.useCallback((message: UiDeployMessage) => {
        if (window.location.host === new URL(message.url).host) {
            snackHandler.warning(messages.getText('messages', 'newReleaseDetected'), {persist: true})
        }
    }, [])

    React.useEffect(() => {
        const window = globalThis.window as any
        if (!window.Cypress) {
            const ws = new OcWebsocket('ui-deploy', undefined, onMessage)
            ws.connect()
            return ws.disconnect
        }
        return undefined
    }, [onMessage])

    return (
        <OcAppBarStateContextProvider>
            <OcThemeProvider>
                <AppDrawer />
            </OcThemeProvider>
            <Box className={classes.fullWidth}>
                <OcThemeProvider>
                    <OcAppBar />
                </OcThemeProvider>
                <Box className={classes.fullHeight}>{children}</Box>
            </Box>
        </OcAppBarStateContextProvider>
    )
}
